import {Button, Spin} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {FC, useState} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';

import {IPutDataGroupCompanyArgs, IGroupCompanyDto} from '../../../api/types';
import {transformFormData} from '../../../lib/edit-group-company-form.utils';
import {IEditGroupCompanyForm} from '../../../model/types';
import {GroupCompanyTabTabService} from '../../../services';
import {GroupCompanyInfoForm} from './group-company-form';

export const EditGroupCompanyForm: FC<IEditGroupCompanyForm> = ({value, fields, fetchData}: IEditGroupCompanyForm) => {
    const [form] = useForm();

    const [formFieldsData, setFormFieldsData] = useState<IGroupCompanyDto>();

    const [isDataLodaing, setIsDataLodaing] = useState<boolean>(true);

    const onFinish = async (values: IPutDataGroupCompanyArgs) => {
        if (!form.isFieldsTouched()) return;
        try {
            const transformedFormData = transformFormData(values);
            await GroupCompanyTabTabService.put(transformedFormData);
            await fetchData();
        } catch (e) {
            console.error(e);
        }
    };

    const onShow = async () => {
        const {data} = await GroupCompanyTabTabService.getById(fields.id);
        
        setFormFieldsData(data);

        form.setFieldsValue({
            id: data.id,
            inn: data.inn,
            statePart: data.statePart,
            companyGroupHoldingInfoDtos: data.companyGroupHoldingInfoDtos,
            companyGroupStatePartInfoDtos: data.companyGroupStatePartInfoDtos,
            companyGroupParticipantInfoDtos: data.companyGroupParticipantInfoDtos,
        });

        setIsDataLodaing(false);
    };

    return (
        <ModalOpenerComponent
            component={<Button type="link">{value}</Button>}
            controlsStyle={{marginTop: '20px'}}
            modalProps={{title: 'Сведения по структуре группы компаний'}}
            controlLabels={{save: 'Сохранить'}}
            handleSave={(setIsModalOpen) => {
                form.validateFields().then(() => {
                    form.submit();
                    setIsModalOpen(false);
                });
            }}
            onShow={onShow}
            shouldConfirm={() => form.isFieldsTouched()}
            handleCancel={(setIsModalOpen) => {
                form.resetFields();
                setIsModalOpen(false);
            }}
        >
            <Spin
                spinning={isDataLodaing}
                tip="Загрузка информации о записи..."
            >
                <GroupCompanyInfoForm<IPutDataGroupCompanyArgs>
                    formInstance={form}
                    onFinish={onFinish}
                    fields={formFieldsData}
                />
            </Spin>
        </ModalOpenerComponent>
    );
};
